import React, { useEffect } from 'react'
import { Box, Typography, Paper, useTheme } from '@mui/material';
import Grid from '../../../common/CustomGrid'; 
import AOS from 'aos';

const MissionVisionValuesSection = ({data}) => {

  const theme = useTheme();

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);

  const { mission = "", values = "", vision = "" } = data || {};

  return (
    <Box sx={{ backgroundColor: '#f4f6fc', py: 8,  px: { xs: 2, md: 6 },  }} >
      <Grid container spacing={1}>
       
        <Grid size={{ xs: 12, md: 4 }} data-aos="fade-up" >
          <Paper elevation={0} sx={{ p: 3, textAlign: 'center', backgroundColor: 'transparent' }} >
            <Typography variant="h6" sx={{ display:'flex', alignItems:'center', justifyContent:'center', color: 'primary.main', mb: 2, fontWeight: 'bold', fontSize: {xs: '2rem', md:'2.4rem'}  }}>
            <span className="icon icon-target" style={{ fontSize: 40, color: theme.palette.primary.main, mb: 2 }}></span> MISIÓN
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6, fontSize: '1rem' }}>
            {mission}
            </Typography>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }} data-aos="fade-up" data-aos-delay="300">
          <Paper elevation={0} sx={{ p: 3, textAlign: 'center', borderRadius: 4, backgroundColor: 'white', }} >
            <Typography variant="h6" sx={{ display:'flex', alignItems:'center', justifyContent:'center', color: 'secondary.main', mb: 2, fontWeight: 'bold', fontSize: {xs: '2rem', md:'2.4rem'}  }}>
            <span className="icon icon-lightbulb" style={{ fontSize: 40, color: theme.palette.secondary.main, mb: 2 }}></span> VISIÓN
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6, fontSize: '1rem' }}>
                {vision}
            </Typography>
          </Paper>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }} data-aos="fade-up" data-aos-delay="600">
          <Paper elevation={0} sx={{ p: 3, textAlign: 'center', backgroundColor: 'transparent', }} >
            <Typography variant="h6" sx={{ display:'flex', alignItems:'center', justifyContent:'center', color: 'primary.main', mb: 2, fontWeight: 'bold', fontSize: {xs: '2rem', md:'2.4rem'} }}>
            <span className="icon icon-gem" style={{ fontSize: 40, color: theme.palette.primary.main, mb: 2 }}></span> VALOR
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6, fontSize: '1rem' }}>
              {values}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MissionVisionValuesSection;
